// eslint-disable-next-line no-unused-vars
import { PerformanceChartState } from '../types';
// eslint-disable-next-line no-unused-vars
import { ReduxState } from '../../../../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {PerformanceChartState} The Stats Leaders state.
 */
export const performanceChartSelector = state => state.statspro.performanceChart;